import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import emailjs from '@emailjs/browser';

// Collection name for contact submissions
const CONTACTS_COLLECTION = 'contacts';

// Initialize EmailJS
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

// Submit contact form (public access)
export const submitContactForm = async (contactData) => {
  try {
    // Save to Firebase first
    const contactToSave = {
      name: contactData.name,
      email: contactData.email,
      phone: contactData.phone || '',
      subject: contactData.subject || '',
      message: contactData.message,
      submittedAt: new Date(),
      status: 'new'
    };

    const docRef = await addDoc(collection(db, CONTACTS_COLLECTION), contactToSave);
    
    // Send email notification using EmailJS
    try {
      const emailParams = {
        name: contactData.name,
        email: contactData.email,
        phone: contactData.phone || 'Not provided',
        subject: contactData.subject || 'General Inquiry',
        message: contactData.message,
        submittedAt: new Date().toLocaleString()
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        emailParams
      );
      
      console.log('Email notification sent successfully');
    } catch (emailError) {
      console.error('Failed to send email notification:', emailError);
      // Don't throw error here - form submission should still succeed
    }
    
    return { id: docRef.id, ...contactToSave };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

// Get all contact submissions (admin only)
export const getContactSubmissions = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, CONTACTS_COLLECTION));
    const contacts = [];
    querySnapshot.forEach((doc) => {
      contacts.push({ id: doc.id, ...doc.data() });
    });
    return contacts.sort((a, b) => b.submittedAt - a.submittedAt);
  } catch (error) {
    console.error('Error getting contact submissions:', error);
    throw error;
  }
};